import * as PopperJS from "@popperjs/core";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons/faQuestionCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CatalogTooltipProvider } from "./CatalogTooltipProvider";

// // // //

export function CatalogTooltip(props: {
    slug: string;
    linkToCatalog?: boolean;
    iconClassName?: string;
    placement?: PopperJS.Placement;
    analyticsEventProperties?: Record<string, string>;
}) {
    const {
        slug,
        linkToCatalog = true,
        iconClassName = "text-slate-500 hover:text-slate-700 transition-colors h-3 cursor-help",
        placement = "auto",
        analyticsEventProperties = {},
    } = props;

    return (
        <CatalogTooltipProvider
            slug={slug}
            linkToCatalog={linkToCatalog}
            placement={placement}
            analyticsEventProperties={analyticsEventProperties}
        >
            {({ setTriggerRef }) => (
                <span ref={setTriggerRef} className="flex">
                    <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className={iconClassName}
                    />
                </span>
            )}
        </CatalogTooltipProvider>
    );
}
